import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/client/components/base/card";

const StrategiesPage = () => (
    <div className="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6">
        <h1 className="text-2xl font-semibold tracking-tight">Strategies</h1>
        <p className="mt-1 text-sm text-muted-foreground">
            Automated trading strategies running on your account.
        </p>

        <Card className="mt-6">
            <CardHeader>
                <CardTitle>Coming soon</CardTitle>
                <CardDescription>Strategies are under construction.</CardDescription>
            </CardHeader>
            <CardContent>
                <ul className="grid gap-1.5 text-sm text-muted-foreground">
                    <li>Run and manage strategies</li>
                    <li>Track status, legs and positions</li>
                    <li>Review performance and logs</li>
                </ul>
            </CardContent>
        </Card>
    </div>
);

export default StrategiesPage;
